import { render } from "./UserPerformance.vue?vue&type=template&id=2bf9a179&scoped=true"
import script from "./UserPerformance.vue?vue&type=script&lang=js"
export * from "./UserPerformance.vue?vue&type=script&lang=js"

import "./UserPerformance.vue?vue&type=style&index=0&id=2bf9a179&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bf9a179"]])

export default __exports__